{
  "1000Plants": "1000+ растений в базе данных",
  "1000PlantsDescription": "Добавляйте растения из базы данных, используйте предложенные подсказки по уходу",
  "actions": "Действия",
  "addCollection": "Добавить коллекцию",
  "add": "Добавить",
  "apply": "Применить",
  "applyGardenPlanTitle": "Применить план \"{planName}\" к проекту?",
  "applyGardenPlanDescription": "Растения из плана будут перенесены в основной проект, а сам план будет удалён.",
  "addEvent": "Добавить событие",
  "addFromPlantDatabase": "Добавить растение из базы данных",
  "addingNewPlant": "Добавление нового растения",
  "addingNewTask": "Добавление новой задачи",
  "additionalCareSteps": "Дополнительные действия по уходу",
  "addNewEvent": "Добавить новое событие",
  "addNewTask": "Добавить новую задачу",
  "addPlant": "Добавить растение",
  "addPlantSpecimen": "Добавить экземпляр растения",
  "addTask": "Добавить задачу",
  "advantages": "Достоинства",
  "advicePlotMapFirst": "Совет: Для более точного размещения участка отобразите карту. Использование карты в проекте можно включить на Шаге 1.",
  "afterDiggingThePlantWillBeTransferredToTheUnplantedOnes": "После выкапывания растение будет перенесено в невысаженные.",
  "afterRemovingThePlantWillBeTransferredToTheUnplantedOnes": "После удаления растение будет перенесено в невысаженные.",
  "allNews": "Все новости",
  "allProjects": "Все проекты",
  "allReminders": "Все напоминания",
  "allPlannedTasks": "Все запланированные задачи",
  "allTutorials": "Все полезные материалы",
  "allUsefulMaterials": "Все полезные материалы",
  "appearance": "Внешний вид",
  "applicationInDesign": "Применение в дизайне",
  "applyingFertilizer": "Внесение удобрений",
  "areYouSureYouWantToDelete": "Вы уверены, что хотите удалить?",
  "areYouSureYouWantToDeleteThisPlan": "Вы уверены, что хотите удалить этот план?",
  "areYouSureYouWantToDeleteThisCollection": "Вы уверены, что хотите удалить эту коллекцию?",
  "areYouSureYouWantToDeleteThisEvent": "Вы уверены, что хотите удалить это событие?",
  "areYouSureYouWantToDigUpAllTheSpecimensOfThisPlant": "Вы уверены, что хотите выкопать все экземпляры данного растения?",
  "areYouSureYouWantToFinish": "Вы уверены, что хотите завершить задачу?",
  "areYouSureYouWantToMakeSnapshot": "Вы уверены, что хотите сделать снимок проекта?",
  "attitudeToLight": "Отношение к освещенности",
  "basePlant": "Базовое растение",
  "basePlant-tooltip": "При выборе базового растения поля вашего растения будут дополнены информацией из базы данных TerraSketch, связанной с данным растением. Вы можете дополнять или редактировать данную информацию. Внесенные изменения видны только вам.",
  "building": "Здание",
  "buildingPlural": "Здания",
  "bush": "Куст",
  "bushPlural": "Кусты",
  "bushCat": "Кусты и травы",
  "bushCatPlural": "Кусты и травы",
  "byClickingLogInWithGoogle": "Нажимая войти с Google выше, вы подтверждаете, что вы прочитали и поняли, а также согласились c ",
  "byClickingSignUpWithGoogle": "Нажимая зарегистрироваться с Google выше, вы подтверждаете, что вы прочитали и поняли, а также согласились c ",
  "cancel": "Отмена",
  "canvasDataDescriptionSeparatlyGrowing": "имеющие запись в списке растений и модель на плане",
  "canvasDataDescriptionSolitariusTemplates": "можно связать с записью растения нажатием на ",
  "canvasDataDescriptionOther": "Другие элементы участка",
  "care": "Уход",
  "careDifficulty": "Сложность ухода",
  "carePlan": "План ухода (запланированные задачи)",
  "category": "Категория",
  "center": "Центрировать",
  "changeBasePlant": "Изменить базовое растение",
  "changePassword": "Смена пароля",
  "changeProjectLocation": "Изменить местоположение проекта",
  "characteristics": "Характеристики",
  "checkAllPlantsFromTheCollection": "Отметить все растения из коллекции",
  "checkYourEmail": "Проверьте, пожалуйста, свою почту, чтобы продолжить.",
  "chooseMode": "Выберите режим",
  "chooseObjectType": "Выберите тип объекта",
  "chooseObjectForm": "Выберите форму объекта",
  "choosePlotType": "Выберите тип участка",
  "chooseProjectImage": "Выберите изображение для проекта",
  "chooseType": "Выберите тип",
  "clearBasePlant": "Очистить базовое растение",
  "clearBasePlantMatchingFields": "Очистить также поля предзаполненные на основе данного базового растения",
  "clearFilters": "Очистить фильтры",
  "clearSorting": "Очистить сортировку",
  "closeEvent": "Закрыть событие",
  "cm": "см",
  "collections": "Коллекции",
  "collections-tooltip": "Коллекции создаются пользователем для удобства. Это может быть вид растения или какая-то его характеристика. Данное поле позволяет структуризировать ваши растения и обеспечить удобную работу в дальнейшем.",
  "combineElementWithPlant": "Объединить элемент с растением",
  "comment": "Комментарий",
  "commonInfo": "Общая информация",
  "completedActions": "Выполненные действия",
  "confidenceInPlantVariety": "Уверенность в сорте",
  "confirm": "Предупреждение",
  "confirmClearBasePlant": "Вы действительно хотите очистить базовое растение",
  "confirmFormCloseTitle": "Вы действительно хотите закрыть форму редактирования растения?",
  "court": "Корт/Площадка",
  "createATaskListAssociatedWithTheProjectAndEnterTheFirstTask": "Создайте список задач, связанный с проектом, и введите первую задачу",
  "createElement": "Создать",
  "createFirstProject": "Создать первый проект",
  "createFirstTask": "Создать первую задачу",
  "createFromTemplate": "Шаблон",
  "createNewProject": "Создать новый проект",
  "createPolygonPlot": "Создать полигональный участок",
  "createTheFirstPlantInTheProject": "Создать в проекте первое растение",
  "createYourFirstProjectDescription1": "Для удобства работы в TerraSketch все организовано в рамках проектов.",
  "createYourFirstProjectDescription2": "Чтобы начать работу, вам надо просто создать новый проект. Вы сами определяете, что подразумевается под проектом. Это может быть участок, дом, отдельная клумба и так далее.",
  "createYourFirstProjectDescription3": "С каждым проектом можно работать по отдельности, создавать план размещения объектов, отмечать места посадки растений, планировать задачи. В разделах Напоминания, Растения, Журнал вы можете работать со сводкой данных по всем проектам сразу.",
  "createYourFirstProjectDescription4": "Мы рекомендуем начинать с максимального масштаба проекта (например, весь участок), а потом, при необходимости, выделять отдельные части в разные проекты.",
  "creatingOfNewProject": "Создание нового проекта",
  "critical": "критический",
  "contacts": "Контакты",
  "continue": "Продолжить",
  "continueWithoutSaving": "Продолжить без сохранения",
  "date": "Дата",
  "dateOfEvent": "Дата события",
  "dateOfPlanting": "Дата посадки",
  "dateOfPlantingUtc": "Дата посадки",
  "dateRange": "Диапазон дат",
  "defaultProjectWithoutPlans": "Проект по умолчанию (без планов)",
  "delete": "Удалить",
  "deleteAccount": "Удалить аккаунт",
  "deleteElement": "Удалить",
  "deleteEvent": "Удалить событие",
  "deletePlant": "Удалить растение",
  "deletePlantConfirm": "Вы действительно хотите удалить это растение?",
  "deletePlantEventsConfirm": "Удалить из журнала также все события, связанные с этим растением",
  "deletePlantFromToDoConfirm": "Ссылка на это растение будет удалена из задач.",
  "deleteProject": "Удалить проект",
  "deleteProjectWithPlantsAndEventsConfirm": "Удалить из журнала также все события, связанные с этими растениями",
  "deleteProjectWithPlantsConfirm": "Удалить из журнала также все растения, связанные с этим проектом",
  "description": "Описание",
  "disadvantages": "Недостатки",
  "disease": "Болезни",
  "digUpAllPlantSpecimens": "Выкопать все экземпляры растений",
  "digUpPlant": "Выкопать растение",
  "doYouReallyWantToDelete": "Вы действительно хотите удалить",
  "doYouReallyWantToDeleteThisAccount": "Вы действительно хотите удалить этот аккаунт?",
  "doYouWantToSaveTheProjectBeforeMovingOnToTheNextStep": "Хотите сохранить проект перед переходом к следующему шагу? Несохраненные изменения будут потеряны.",
  "draw": "Нарисовать",
  "duplicatePlant": "Продублировать растение",
  "edge": "Граница",
  "edibility": "Съедобность",
  "edit": "Редактировать",
  "editedInAnotherStep": "Выделенный элемент редактируется на другом шаге",
  "editElement": "Редактировать",
  "editGardenPlan": "Переименовать план",
  "editingPlant": "Редактирование растения",
  "editor": "Редактор участка",
  "editPlant": "Редактировать растение",
  "editProject": "Редактировать проект",
  "editStepDefGenInfo": "Ввести общую информацию о проекте.",
  "editStepDefPlot": "Создать основу участка.",
  "editStepDefSoftscape": "Создать зеленые зоны участка.",
  "editStepDefHardscape": "Создать площадки и дорожки.",
  "editStepDefBuildings": "Создать строения и ограждения.",
  "editStepDefLargePlants": "Разместить крупные растения.",
  "editStepDefWaterscape": "Создать водные объекты.",
  "editStepDefSolitarius": "Разместить отдельные растения.",
  "editStepDefOtherElements": "Создать другие элементы.",
  "editTask": "Редактировать задачу",
  "ellipse": "Эллипсоидальный",
  "email": "Электронная почта",
  "emailIsIncorrect": "Введенное значение не является адресом электронной почты.",
  "emailUs": "Напишите нам",
  "enterProjectLocation": "Ввести местоположение проекта",
  "endDate": "Дата окончания",
  "enterObjectName": "Введите название объекта",
  "enterPlotEdgesDimensions": "Введите размеры границ участка",
  "enterResetEmail": "Введите адрес почты для сброса пароля",
  "entrance": "Входная группа",
  "entrancePlural": "Входные группы",
  "errorDuringLogin": "Ошибка входа",
  "eventCategory": "Категория события",
  "eventEndDate": "Дата завершения события",
  "eventInfo": "Информация о событии",
  "eventPhotos": "Фотографии",
  "eventName": "Название события",
  "eventType": "Тип события",
  "failedToDeleteTask": "не удалось удалить задачу",
  "family": "Семейство",
  "familyRu": "Семейство (рус.)",
  "familyLa": "Семейство",
  "faq": "Часто задаваемые вопросы",
  "faqAnswer1": "Базовая функциональность продукта является бесплатной для всех пользователей. Имеются платные тарифы, добавляющие дополнительные возможности, например, загрузку большего количества своих фотографий.",
  "faqAnswer2": "База данных растений заполняется нашими экспертами и ежедневно пополняется новыми экземлярами.  Все фотографии, размещенные в базе данных растений, представляют собой уникальный контент, получены разработчиками продукта и принадлежат правообладателю продукта.",
  "faqAnswer3": "На данный момент мобильное приложение находится в разработке. Пользователям доступна мобильная версия сайта, адаптированная для использования на малых экранах.",
  "faqAnswer4": "Пользовательские данные принадлежат исключительно пользователям, хранятся на сервере, не используются в базе данных растений продукта и недоступны другим пользователям.",
  "faqQuestion1": "Является ли продукт платным?",
  "faqQuestion2": "Откуда берется информация в базе растений?",
  "faqQuestion3": "Имеется ли мобильное приложение TerraSketch?",
  "faqQuestion4": "Как используются и кому доступны мои данные?",
  "featuresOfCultivation": "Особенности выращивания",
  "featuresOfFruitStorage": "Особенности хранения плодов",
  "featuresOfStoringPlantingMaterial": "Особенности хранения посадочного материала",
  "fence": "Ограждение",
  "fertilizerFrequency": "Частота внесения удобрений",
  "fertilizers": "Удобрения",
  "fieldIsRequired": "Поле {field} является обязательным",
  "filter": "Фильтр",
  "filters": "Фильтры",
  "filtersAndSorting": "Фильтры и сортировка",
  "filtersUp": "Фильтры",
  "finish": "Завершить",
  "finishTask": "Завершить задачу",
  "finishToDo": "Завершить задачу и поместить ее в архив",
  "flowerCat": "Цветы",
  "flowerCatPlural": "Цветы",
  "flowerbed": "Клумба",
  "flowerbedPlural": "Клумбы",
  "flowerColor": "Цвет цветов",
  "flowersPhotos": "Фотографии цветов",
  "flowerSize": "Размер цветов (соцветий)",
  "forgotPassword": "Забыли пароль",
  "formModifiedButNotSaved": "Растение было модифицировано, но не сохранено.",
  "from": "от",
  "from2": "из",
  "fruiting": "Плодоношение",
  "fruitingTime": "Время плодоношения",
  "fruitMass": "Масса плодов",
  "fruitsPhotos": "Фотографии плодов",
  "furniture": "Мебель",
  "furniturePlural": "Мебель",
  "g": "г",
  "cards": "Карточки",
  "gallery": "Галерея",
  "garden": "Сад",
  "gardenPlan": "План сада",
  "gardenPlanVariantsHint": "Варианты плана позволяют добавлять запланированные, но ещё не посаженные растения и сравнивать разные варианты посадок. Одновременно отображается только один вариант. Вариант можно применить к проекту, и тогда он станет его частью.",
  "gardeningWork": "Садово-огородные работы",
  "gardenPlural": "Сады",
  "gardenJournal": "Садовый дневник",
  "gardenJournalDescription": "Сохраняйте записи о посаженных растениях и особенностях ухода за ними на протяжении многих лет",
  "greenhouse": "Теплица",
  "growing-conditions": "Условия произрастания",
  "growthRate": "Скорость роста",
  "hedge": "Живая изгородь",
  "hedgePlural": "Живые изгороди",
  "height": "Высота",
  "hideElementOnSitePlan": "Спрятать элемент на плане участка",
  "hideGardenPlanVariantPlants": "Скрыть растения из вариантов плана",
  "hidePlantOnSitePlan": "Спрятать растение на плане участка",
  "home": "Домашняя страница",
  "ifYouDontHaveAccount": "Если у вас нет аккаунта ",
  "ifYouHaveAccount": "Если у вас уже есть аккаунт ",
  "importance": "Приоритет",
  "informationAboutWhichPlantsBelongedToThisCollectionWillAlsoBeRemoved": "Информация о том, какие растения относились к этой коллекции, также будет удалена.",
  "isRequired": "- обязательно для заполнения",
  "journal": "Дневник",
  "landingPlantHydrangea": "Гортензия крупнолистная Madame Emile Mouillere",
  "landingPlantBerberis": "Барбарис Тунберга Admiration",
  "landingPlantSymphotrichum": "Астра кустарниковая",
  "landingPlantCrocus": "Крокус",
  "landingPlantDasiphora": "Лапчатка кустарниковая Pink Beauty",
  "landingPlantAnemone": "Анемона гибридная Serenade",
  "landingPlantSedum": "Очитник видный",
  "lastWeek": "Последняя неделя",
  "lastMonth": "Последний месяц",
  "last90days": "Последние 90 дней",
  "lastYear": "Псоледний год",
  "lawn": "Газон",
  "lawnPlural": "Газоны",
  "leafColor": "Цвет листьев",
  "leafPhotos": "Фотографии листьев",
  "length": "Длина",
  "lifeCycle": "Жизненный цикл",
  "lighting": "Освещение",
  "lightingPlural": "Освещение",
  "location": "Расположение",
  "locationPlant": "Размещение",
  "locationReference": "Расположение - привязка к географическим координатам",
  "locationReferenceInfo": "Вы можете использовать расположение проекта для добавления карты местности в проект и отображения актуальной погоды на вашем участке.",
  "logIn": "Войти",
  "logInWithGoogle": "Зайти с Google",
  "logOut": "Выйти",
  "low": "низкий",
  "m": "м",
  "mainInfo": "Главная информация",
  "makeSnapshot": "Сделать снимок",
  "makingSnapshotDescription": "Снимок проекта представляет собой нередактируемую копию проекта на определенную дату. Копия содержит перечень размещенных на проекте участков и растений.",
  "mapCoordinatesWillBeReset": "Координаты карты будут перезаписаны",
  "mapNotFound": "Карта не найдена. Сохраните карту на шаге 1 редактирования проекта.",
  "medicalProperties": "Медицинские свойства",
  "meter": "метр(-а,-ов)",
  "metricSystem": "Метрическая система",
  "myCollections": "Мои коллекции",
  "myPhotos": "Мои фотографии",
  "myPlants": "Mои растения",
  "myPlantTimeline": "Моя хронология растения",
  "myProjects": "Мои проекты",
  "mySnapshots": "Мои снимки",
  "myToDos": "Мои списки задач",
  "name": "Название",
  "nameOfTask": "Название задачи",
  "next": "Далее",
  "newCollection": "Новая коллекция",
  "newGardenPlan": "Новый план",
  "newPassword": "Новый пароль",
  "news": "Новости",
  "newTaskAdding": "Добавление новой задачи",
  "newTaskList": "Создать новый список задач",
  "newTypeName": "Новый тип",
  "no": "нет",
  "noEntries": "нет записей",
  "noInformationAboutProjectLocation": "нет информации о местоположении проекта",
  "normal": "средний",
  "noTemplatesForThisType": "Для данного типа нет шаблонов",
  "noTitle": "нет названия",
  "notPlanted": "не высажено",
  "nowUsingBasePlant": "На основе растения из базы TerraSketch",
  "objectName": "Название объекта",
  "objectParameters": "Параметры объекта",
  "objectType": "Тип объекта",
  "onElement": "на участке",
  "onlineEditor": "Редактор участка онлайн",
  "onlineEditorDescription": "Создавайте план своего участка и размещайте на нем посаженные растения",
  "openPlantDescription": "Открыть описание растения",
  "other": "Другое",
  "otherPlural": "Другое",
  "otherNames": "Другие названия",
  "otherNews": "Другие новости",
  "otherSiteElements": "Другие элементы участка",
  "overview": "Общее описание",
  "overwriteBasePlant": "Заменить базовое растение",
  "password": "Пароль",
  "passwordMismatch": "Пароли не совпадают",
  "passwordValidation": "Используйте латинские буквы (a–z, A–Z), как минимум одну цифру и не менее 6 символов.",
  "pastEvents": "Прошедшие события",
  "pathway": "Дорожка",
  "pathwayPlural": "Дорожки",
  "patio": "Патио",
  "pesticides": "Пестициды",
  "pesticideTreatmentFrequency": "Частота обработки пестицидами",
  "pests": "Вредители",
  "photos": "Фотографии",
  "placeTheMap": "Разместите карту в окне так, чтобы она покрывала всю территорию, необходимую вам в дальнейшем для планирования участка (сам участок, примыкающие дороги и т.д.)",
  "plantFromGardenPlan": "Растение добавлено в выбранном плане и не входит в исходный проект",
  "gardenPlanTag": "План",
  "plantIsCreatedInGardenPlan": "Растение создаётся в рамках плана «{planName}»",
  "planningModeWarning": "Вы в режиме планирования: растения будут сохранены в выбранном плане и не будут добавлены в исходный проект. Вы не можете перемещать растения из основного проекта пока режим активен.",
  "plannedCompletionDate": "Запланированная дата выполнения",
  "plannedTasks": "Запланированные задачи",
  "plant": "Растение",
  "plant-health": "Здоровье растения",
  "plantcomposition": "Композиция растений",
  "plantcompositionPlural": "Композиции растений",
  "plantDatabase": "База данных растений",
  "plantDesignationOnTheMap": "Обозначение на карте",
  "plantedDate": "Дата посадки",
  "plantedIn": "Высажено в проекте",
  "planted": "высажено",
  "plantedPlants": "Высаженные растения",
  "plantingAndReproduction": "Посадка и выращивание",
  "plantingDepth": "Глубина посадки",
  "plantingSeedlingsInClosedGround": "высадка на рассаду в закрытый грунт",
  "plantingSeedlingsInOpenedGround": "высадка в открытый грунт",
  "plantingWork": "Посадочные работы",
  "plantModelWithoutPlantRecord": "Модели растений без привязки к записи",
  "plantName": "Название растения",
  "plantName-tooltip": "В данном поле указывается ваше название растения. Оно может совпадать с общераспространенным названием или быть более специфическим, например, указывать еще на месторасположение у вас на участке или дополнительные признаки. Указание более специфического названия облегчит для вас работу с этим растением в дальнейшем, особенно при наличии на участке нескольких подобных растений.",
  "plantPageWorkWithTodo": "Работа с задачами со страницы растения",
  "plantPhotos": "Фотографии растения",
  "plantPlant": "Посадить растение",
  "plants": "Растения",
  "plantsTaskList": "Другие задачи, связанные с растениями",
  "plantTypeDistributionDiagram": "Диаграмма распределения типов растений",
  "plotWillBeDeleted": "участок будет удален",
  "policy": "Политики и правила использования",
  "policyTerrasketch": "Политиками и правилами использования TerraSketch",
  "polygon": "Полигональный",
  "pond": "Пруд",
  "pool": "Бассейн/Пруд",
  "preserveMapCoordinates": "Оставить координаты карты",
  "project": "Проект",
  "projectChangedSaveBeforeProceedingToTheNextStep": "Проект изменен. Сохраните перед переходом к следующему шагу.",
  "projectComposition": "Композиция проекта",
  "projectCoordinates": "Координаты",
  "projectDescription": "Описание проекта",
  "projectIsNotSaved": "В проекте имеются несохраненные изменения.",
  "projectName": "Название проекта",
  "projectPage": "Страница проекта",
  "projectPageTour": "Как работать с проектом?",
  "projectPageTourDescriptionAll": "На странице проекта вы можете просматривать отдельные элементы проекта, добавлять новые растения и отмечать их на плане участка.",
  "projectPageTourDescriptionEdit": "Переход в режим редактирования проекта. В этом режиме возможно редактирование описания проекта, размещение новых и редактирование уже добавленных элементов участка.",
  "projectPageTourDescriptionAddPlant": "При добавлении нового растения вы можете использовать информацию из базы TerraSketch как основу или можете создать запись с чистого листа.",
  "projectPageTourDescriptionCanvas": "Посадить растение - значит, разместить его на плане участка проекта. Чтобы посадить растение, необходимо добавить запись о нем в проект, затем выделить эту запись на вкладке 'Невысаженные растения' и нажать на кнопку 'Посадить растение'.",
  "projectPageTourDescriptionSnapshot": "Вы можете сохранить текущее состояние участка в виде снимка проекта. Рекомендуем делать снимок хотя бы 1 раз за сезон.",
  "projectPageTourDescriptionReminders": "Отображаются 10 наиболее актуальных задач, связанных с данным проектом. Работа со списком задач осуществляется на странице Планирование.",
  "projects": "Проекты",
  "projectOverview": "Обзор проекта",
  "projectsOverview": "Обзор проектов",
  "projectSketch": "Скетч проекта",
  "projectSnapshot": "Снимок проекта",
  "projectReminders": "Напоминания по проекту",
  "propagation-planting": "Размножение и посадка",
  "properties": "Свойства",
  "purposeLocation": "Назначение/местоположение",
  "putObjectOnThePlan": "Разместите объект на плане",
  "rect": "Прямоугольный",
  "reminders": "Напоминания",
  "removePlantSpecimen": "Удалить экземпляр растения",
  "repeatPassword": "повторите пароль",
  "repeatNewPassword": "Повторите новый пароль",
  "replantPlant": "Пересадить растение",
  "reproductionMethods": "Способы размножения",
  "requiredField": "${label} обязательно для заполнения",
  "resetFilters": "Сбросить фильтры",
  "resetPassword": "Сброс пароля",
  "ruler": "Линейка",
  "save": "Сохранить",
  "saveAndContinue": "Сохранить и продолжить",
  "saveEvent": "Сохранить событие",
  "searchForBasePlant": "Введите название для поиска по базе растений",
  "searchForLocation": "Поиск местоположения",
  "searchForNews": "Поиск новостей",
  "searchingPlantBase": "Поиск по базе",
  "seeAllProjects": "Посмотреть все проекты",
  "seeAllReminders": "Перейти ко всем напоминаниям",
  "select": "Выбрать",
  "selectAnElementForDeleting": "Выделите элемент для удаления",
  "selectAnObjectForEditing": "Выделите элемент для редактирования",
  "selectPlantsFromTheMarkedCollections": "Выбрать растения из отмеченных коллекций",
  "selectPlantForConnection": "Выберите растение для связи c ",
  "selectPlantForConnectionNote": "Примечание: После нажатия на кнопку 'Ок' изменится отображение всех экземпляров выбранного растения",
  "selectTemplateOrDrawingTool": "Выберите шаблон или инструмент для рисования",
  "selectTheTaskCompletionDate": "Выберите дату завершения задачи",
  "sendEmailToResetPassword": "Отправить письмо для сброса пароля",
  "separatelyGrowing": "Отдельно растущие",
  "showGridWithSpacing": "Отобразить сетку с шагом ",
  "showMap": "Отобразить карту",
  "showElementOnSitePlan": "Показать элемент на плане участка",
  "showPlantOnSitePlan": "Показать растение на плане участка",
  "side": "Сторона",
  "signUp": "Зарегистрироваться",
  "signUpWithGoogle": "Зарегистрироваться c Google",
  "size-appearance": "Размер и внешний вид",
  "sloganElevate": "Новый уровень садоводства",
  "snapshot": "Снимок проекта",
  "snapshots": "Снимки проектов",
  "soil": "Почва (субстрат)",
  "solitarius": "Солитер",
  "sortBy": "Сортировать по",
  "sorting": "Сортировка",
  "sortingBy": "Сортировка по",
  "sortingDirectionAsc": "по возрастанию",
  "sortingDirectionDesc": "по убыванию",
  "specification": "Уточняющая характеристика",
  "spreading": "Раскидистость",
  "stairs": "Лестница",
  "stairsPlural": "Лестницы",
  "startDate": "Дата начала",
  "startToday": "Начать сегодня",
  "step": "Шаг",
  "structure": "Беседка/павильон",
  "structurePlural": "Беседки/павильоны",
  "subSloganElevate": "Откройте для себя платформу TerraSketch, трансформирующую подход к планированию и уходу за участком. Наша платформа не только поможет визуализировать ваш идеальный сад, но и будет сопровождать вас на каждом этапе его роста. Начните свой путь с TerraSketch уже сегодня и наблюдайте, как ваш сад расцветает.",
  "table": "Таблица",
  "tag-news": "новости",
  "tag-tutorials": "полезные материалы",
  "taskAndEventFilters": "Фильтры задач и событий",
  "taskDeleting": "Удаление задачи",
  "taskDescription": "Описание задачи",
  "taskEditing": "Редактирование задачи",
  "taskFinishing": "Завершение задачи",
  "taskPlanner": "Планировщик задач",
  "taskPlannerDescription": "Составляйте списки задач по участку, проводите мониторинг роста и состояния растений",
  "taskType": " Тип задачи",
  "taskTypes": " Типы задачи",
  "taxonomy": "Таксономия",
  "terrace": "Терраса",
  "terracePlural": "Террасы",
  "terraSketchEditor": "Редактор участка TerraSketch",
  "terraSketchEditorDescription1": "Визуализируйте основные зоны и объекты на плане вашего участка",
  "terraSketchEditorDescription2": "Отмечайте и каталогизируйте растения, которые вы посадили на участке",
  "terraSketchEditorDescription3": "Используйте историю ваших посадок для организации севооборота",
  "terraSketchEditorDescription4": "Оценивайте объем посадочных и других расходных материалов, необходимых для ваших садовых проектов",
  "terraSketchEditorDescription5": "Фиксируйте состояние вашего участка на конкретные даты, документируя рост и трансформации со временем",
  "terraSketchTaskPlanner": "Планировщик задач TerraSketch",
  "terraSketchTaskPlannerDescription1": "Создавайте индивидуальные списки задач для вашего садового участка, идеально соответствующие уникальным потребностям вашего сада",
  "terraSketchTaskPlannerDescription2": "Внимательно следите за состоянием и здоровьем ваших растений",
  "terraSketchTaskPlannerDescription3": "Записывайте этапы роста и развития ваших растений на специальных временных шкалах",
  "terraSketchTaskPlannerDescription4": "Анализируйте историю вашего участка с помощью журнала садовода",
  "terraSketchPlantDatabase": "База данных растений TerraSketch",
  "terraSketchPlantDatabaseDescription": "Сердце TerraSketch — наша постоянно расширяющаяся база растений, где более 1000 записей уже ждут, чтобы вдохновить и направить ваше садоводческое путешествие. Каждая запись, с любовью созданная нашими разработчиками, содержит фотографии, подробные описания и индивидуальные рекомендации по уходу. Вырастите для себя сад мечты вместе с TerraSketch, где каждое растение вдохновляет и рассказывает свою историю.",
  "thePlantIsInTheProject": "Растение находится в проекте",
  "thePlantWasRemovedByTheUser": "Растение было удалено пользователем",
  "theLatestPostsAndGuides": "Последние опубликованные новости и полезные материалы. Выберите статью, чтобы прочитать полный текст.",
  "thisIsTheOnlyPlantedSpecimenOfThisPlant": "Это единственный высаженный экземпляр данного растения.",
  "thisOperationIsIrreversible": "Эта операция необратима.",
  "tile": "Плитка",
  "tilePlural": "Плитка",
  "timeForPlantingSeedlingsInClosedGround": "Время посадки на рассаду в закрытый грунт",
  "timeForPlantingSeedlingsInOpenedGround": "Время посадки на рассаду в открытый грунт",
  "today": "Сегодня",
  "todoGroup-overdue": "Просрочено",
  "todoGroup-today": "Сегодня",
  "todoGroup-tomorrow": "Завтра",
  "todoGroup-laterThisWeek": "На этой неделе",
  "todoGroup-laterThisMonth": "В этом месяце",
  "todoGroup-nextMonth": "В следующем месяце",
  "todoGroup-later": "Позднее",
  "todoGroup-noDate": "Без даты",
  "toDisplayWeather": "Для отображения погоды и связанных рекомендаций введите местоположение проекта в настройках",
  "todoLists": "Списки задач",
  "todoPage": "Страница задач",
  "todoPageTour": "Как работать с задачами?",
  "todoPageTourDescriptionAll": "На странице задач вы можете создавать, редактировать и просматривать задачи, связанные с растениями или другими работами.",
  "todoPageTourDescriptionAdd": "При создании новой задачи вы можете использовать один из стандартных типов (например, обрезка) или добавить свой. Типы помогают структурировать в дальнейшем жизненный цикл растения, а также группировать разные задачи по саду. Также вы можете связать создаваемую задачу с добавленными вами ранее растениями, задать желаемые сроки выполнения и первоочередность задачи.",
  "todoPageTourDescriptionList": "Все созданные ранее задачи отображаются на странице в виде карточек.",
  "todoPageTourDescriptionFilter": "Исользуйте фильтр и сортировку для повышения эффективности организации своей работы. Например, вы можете отобразить задачи, связанные только с конкретным растением или запланированные на ближайшие выходные.",
  "todoPageTourDescriptionEdit": "Для редактирования и просмотра более подробной информации о задаче нажмите на значок карандаша на карточке задачи.",
  "todoPageTourDescriptionEndTask1": "Чтобы успешно завершить задачу, нажмите на значок птички. При завершении укажите актуальную дату выполнения задачи и, при необходимости, исправьте тип выполненной задачи. ",
  "todoPageTourDescriptionEndTask2": "После завершения задача преобразовывается в событие, которое произошло в указанную вами дату. Если задача была привязана одновременно к нескольким растениям, то при завершении задачи произойдет создание события для каждого из перечисленных растений. ",
  "todoPageTourDescriptionEndTask3": "Вы можете всегда посмотреть список выполненных задач (событий) в Дневнике или на странице соответствующего связанного с задачей растения.",
  "todoPageTourDescriptionDeleteTask": "Удалить полностью задачу можно нажав на значок корзины. При этом задача не попадет в дневник, а будет удалена без возможности нахождения данной информации.",
  "todoPageTourDescriptionPlantPage": "Работать с задачами можно также со страниц добавленных вами растений. Вся информация о добавленных, отредактированных или завершенных таким способом задачах будет видна также и на странице Мои списки задач.",

  "totalPlantsInTheProject": "Всего растений в проекте",
  "toxicity": "Ядовитость",
  "tree": "Дерево",
  "treeCat": "Деревья",
  "treeCatPlural": "Деревья",
  "trimTime": "Время обрезки",
  "thisOperationWillMoveTask": "Эта операция переместит задачу в дневник.",
  "thisMonth": "Этот месяц",
  "thisWeek": "Эта неделя",
  "type": "Тип",
  "typeOfTheCorrespondingTasksAndEventsWillBeChangedToGeneral": "Тип соответстующих задач и событий будет изменен на Общий.",
  "unplantedPlants": "Невысаженные растения",
  "uploadPhotos": "Добавить фотографии",
  "uploadPlantPhotos": "Добавить фотографии растения",
  "urgent": "срочный",
  "usage": "Использование",
  "uSDA": "USDA-зоны",
  "usefulMaterials": "Полезные материалы",
  "useMapForProjectCreating": "Использовать карту при создании проекта",
  "useMyCurrentLocation": "Использовать мое текущее местоположение",
  "usePlotDrawingTool": "Воспользуйтесь инструментом для рисования участка",
  "userAccount": "Кабинет пользователя",
  "userEmail": "Email пользователя",
  "userInfo": "Информация пользователя",
  "userName": "Имя пользователя",
  "userSettings": "Настройки пользователя",
  "variety": "Сорт",
  "varietyEng": "Сорт",
  "varietyRu": "Сорт (рус.)",
  "vegetableCat": "Овощи",
  "vegetableCatPlural": "Овощи",
  "vegetablegarden": "Грядка",
  "vegetablegardenPlural": "Грядки",
  "water": "Вода - другие элементы",
  "waterPlural": "Вода",
  "watering": "Полив",
  "width": "Ширина",
  "yes": "да",
  "yourActionsCannotBeUndone": "Данное действие не может быть отменено",

  "metricSystemTooltip": "Метрическая система определяет единицы, в которых будут в приложении отображаться измеряемые величины",
  "userNameTooltip": "Имя пользователя используется только внутри приложения для удобства",

  "commonName": "Общераспространенное название",
  "scienceName": "Научное название",
  "element": "Участок",
  "heightFrom": "Высота от (м)",
  "heightTo": "Высота до (м)",
  "height-rangeField": "Высота (м)",
  "spreadingFrom": "Раскидистость от (м)",
  "spreadingTo": "Раскидистость до (м)",
  "spreading-rangeField": "Раскидистость (м)",
  "flowerSize-rangeField": "Размер цветов/соцветий (см)",
  "attractionFactors": "Факторы привлекательности",
  "bloomingTime": "Время цветения",

  "eventType-": " ",
  "eventType-planting": "посадка",
  "eventType-repotting": "пересадка",
  "eventType-propagation": "размножение",
  "eventType-seedsowing": "посев семян",
  "eventType-seedlingsemerge": "появление всходов",
  "eventType-trueleaves": "настоящие листья",
  "eventType-prickingout": "пикировка",
  "eventType-hardeningoff": "закаливание",
  "eventType-transplanting": "высадка в грунт",
  "eventType-harvesting": "сбор урожая",
  "eventType-pruning": "обрезка",
  "eventType-weeding": "прополка",
  "eventType-fertilizing": "удобрение",
  "eventType-blooming": "цветение",
  "eventType-watering": "полив",
  "eventType-trimming": "стрижка",
  "eventType-chemicals": "обработка химикатами",
  "eventType-buying": "покупка",
  "eventType-general": "общее",
  "eventType-preplanting": "подготовка посадочного материала",
  "eventType-winter": "подготовка к зиме",

  "uSDA-tooltip": "Зоны морозостойкости - географически определенные территории со сходными климатическими условиями",
  "uSDA-0": "0",
  "uSDA-1": "1",
  "uSDA-2": "2",
  "uSDA-3": "3",
  "uSDA-4": "4",
  "uSDA-5": "5",
  "uSDA-6": "6",
  "uSDA-7": "7",
  "uSDA-8": "8",
  "uSDA-9": "9",
  "uSDA-10": "10",
  "uSDA-11": "11",
  "uSDA-12": "12",

  "январь": "январь",
  "февраль": "февраль",
  "март": "март",
  "апрель": "апрель",
  "май": "май",
  "июнь": "июнь",
  "июль": "июль",
  "август": "август",
  "сентябрь": "сентябрь",
  "октябрь": "октябрь",
  "ноябрь": "ноябрь",
  "декабрь": "декабрь",
  "после минования угрозы заморозков": "после минования угрозы заморозков",

  "careDifficulty-низкая": "низкая",
  "careDifficulty-средняя": "средняя",
  "careDifficulty-высокая": "высокая",

  "purposeLocation-контейнерное": "контейнерное",
  "purposeLocation-комнатное": "комнатное",
  "purposeLocation-уличное": "уличное",
  "purposeLocation-сезонное": "сезонное",

  "lifeCycle-многолетнее": "многолетнее",
  "lifeCycle-двухлетнее": "двухлетнее",
  "lifeCycle-однолетнее": "однолетнее",

  "watering-частый": "частый",
  "watering-1 раз в неделю": "1 раз в неделю",
  "watering-2 раза в неделю": "2 раза в неделю",
  "watering-умеренный": "умеренный",
  "watering-редкий": "редкий",
  "watering-по мере необходимости": "по мере необходимости",
  "watering-не требует дополнительного полива": "не требует дополнительного полива",
  "watering-постоянно влажная почва": "постоянно влажная почва",

  "attitudeToLight-солнце": "солнце",
  "attitudeToLight-полутень": "полутень",
  "attitudeToLight-тень": "тень",
  "attitudeToLight-легкая полутень": "полутень",
  "attitudeToLight-рассеянный свет": "свет",
  "attitudeToLight-яркий рассеянный свет": "свет",

  "edibility-бутоны": "бутоны",
  "edibility-клубни": "клубни",
  "edibility-корни": "корни",
  "edibility-листья": "листья",
  "edibility-луковица": "луковица",
  "edibility-медицинские свойства": "медицинские свойства",
  "edibility-молодые побеги": "молодые побеги",
  "edibility-овощи": "овощи",
  "edibility-плоды": "плоды",
  "edibility-семена": "семена",
  "edibility-соцветия": "соцветия",
  "edibility-фрукты": "фрукты",
  "edibility-ягоды": "ягоды",

  "toxicity-все части": "все части",
  "toxicity-кора": "кора",
  "toxicity-корни": "корни",
  "toxicity-листья": "листья",
  "toxicity-плоды": "плоды",
  "toxicity-сок": "сок",
  "toxicity-стебель": "стебель",
  "toxicity-цветы": "цветы",
  "toxicity-ядовитое": "ядовитое",

  "type-вереск": "вереск",
  "type-водное": "водное",
  "type-вьющиеся и лианы": "вьющиеся и лианы",
  "type-дерево": "дерево",
  "type-кактусы и суккуленты": "кактусы и суккуленты",
  "type-клубнелуковичное": "клубнелуковичное",
  "type-кустарник": "кустарник",
  "type-луковичное": "луковичное",
  "type-пальмовые и саговниковые": "пальмовые и саговниковые",
  "type-папоротник": "папоротник",
  "type-плотоядное": "плотоядное",
  "type-полукустарник": "полукустарник",
  "type-травянистое": "травянистое",
  "type-цветущее": "цветущее",
  "type-небольшое дерево": "небольшое дерево",
  "type-эпифит": "эпифит",

  "attractionFactors-ампельное": "ампельное",
  "attractionFactors-быстрорастущее": "быстрорастущее",
  "attractionFactors-всесезонная декоративность": "всесезонная декоративность",
  "attractionFactors-гигрофит": "гигрофит",
  "attractionFactors-декоративная кора": "декоративная кора",
  "attractionFactors-декоративная форма кроны": "декоративная форма кроны",
  "attractionFactors-декоративное плодоношение": "декоративное плодоношение",
  "attractionFactors-декоративное цветение": "декоративное цветение",
  "attractionFactors-декоративнолиственное": "декоративнолиственное",
  "attractionFactors-ксерофит": "ксерофит",
  "attractionFactors-медленнорастущее": "медленнорастущее",
  "attractionFactors-морозостойкое": "морозостойкое",
  "attractionFactors-очищает воздух": "очищает воздух",
  "attractionFactors-плетущееся": "плетущееся",
  "attractionFactors-почвопокровное": "почвопокровное",
  "attractionFactors-привлекающее опылителей": "привлекающее опылителей",
  "attractionFactors-продолжительное цветение": "продолжительное цветение",
  "attractionFactors-съедобное": "съедобное",
  "attractionFactors-теневыносливое": "теневыносливое",
  "attractionFactors-тенелюбивое": "тенелюбивое",
  "attractionFactors-топиарные формы": "формы",
  "attractionFactors-хвойное": "хвойное",
  "attractionFactors-цветение в ранневесенний период": "цветение в ранневесенний период",
  "attractionFactors-экзотический внешний вид": "экзотический внешний вид",

  "featuresOfCultivation-необходима предварительная высадка на рассаду в закрытый грунт": "необходима предварительная высадка на рассаду в закрытый грунт",
  "featuresOfCultivation-возможна предвариательная высадка на рассаду": "возможна предвариательная высадка на рассаду",
  "featuresOfCultivation-предварительное проращиевание клубней": "предварительное проращиевание клубней",
  "featuresOfCultivation-стратификация посадочного материала": "стратификация посадочного материала",
  "featuresOfCultivation-дополнительная обработка посадочного материала": "дополнительная обработка посадочного материала",
  "featuresOfCultivation-есть период покоя": "есть период покоя",
  "featuresOfCultivation-возможен посев семян в грунт под зиму": "возможен посев семян в грунт под зиму",
  "featuresOfCultivation-скарификация семян при посадке весной": "скарификация семян при посадке весной",

  "reproductionMethods-боковыми побегами": "боковыми побегами",
  "reproductionMethods-делением клубня": "делением клубня",
  "reproductionMethods-делением корневища": "делением корневища",
  "reproductionMethods-делением куста": "делением куста",
  "reproductionMethods-клубнелуковицами": "клубнелуковицами",
  "reproductionMethods-клубнепочками": "клубнепочками",
  "reproductionMethods-листом": "листом",
  "reproductionMethods-луковицами": "луковицами",
  "reproductionMethods-луковичными чешуйками": "луковичными чешуйками",
  "reproductionMethods-отводками": "отводками",
  "reproductionMethods-прививкой": "прививкой",
  "reproductionMethods-семенами": "семенами",
  "reproductionMethods-спорами": "спорами",
  "reproductionMethods-частью листа": "частью листа",
  "reproductionMethods-черенкованием": "черенкованием",

  "timeForPlantingSeedlingsInOpenedGround-после минования угрозы заморозков": "после минования угрозы заморозков",

  "additionalCareSteps-обрезка на зиму": "обрезка на зиму",
  "additionalCareSteps-омолаживающая обрезка": "омолаживающая обрезка",
  "additionalCareSteps-поллардинг": "поллардинг",
  "additionalCareSteps-прищипывание": "прищипывание",
  "additionalCareSteps-санитарная обрезка": "санитарная обрезка",
  "additionalCareSteps-удаление увядших цветов": "удаление увядших цветов",
  "additionalCareSteps-укрытие на зиму": "укрытие на зиму",
  "additionalCareSteps-формовочная обрезка": "формовочная обрезка",
  "additionalCareSteps-хранение зимой в помещении": "хранение зимой в помещении",

  "applicationInDesign-аквариум": "аквариум",
  "applicationInDesign-аллея": "аллея",
  "applicationInDesign-альпийская горка (альпинарий)": "альпийская горка (альпинарий)",
  "applicationInDesign-балкон": "балкон",
  "applicationInDesign-берсо": "берсо",
  "applicationInDesign-бонсай": "бонсай",
  "applicationInDesign-бордюр": "бордюр",
  "applicationInDesign-в интерьере": "в интерьере",
  "applicationInDesign-вертикальное озеленение": "вертикальное озеленение",
  "applicationInDesign-гербарий": "гербарий",
  "applicationInDesign-групповая посадка": "групповая посадка",
  "applicationInDesign-декоративный мини-водоем": "декоративный мини-водоем",
  "applicationInDesign-живая изгородь": "живая изгородь",
  "applicationInDesign-кашпо": "кашпо",
  "applicationInDesign-клумба": "клумба",
  "applicationInDesign-контейнер": "контейнер",
  "applicationInDesign-кулисы": "кулисы",
  "applicationInDesign-миксбордер": "миксбордер",
  "applicationInDesign-мобильный прудик": "мобильный прудик",
  "applicationInDesign-оформление букета": "оформление букета",
  "applicationInDesign-пальметта": "пальметта",
  "applicationInDesign-рабатка": "рабатка",
  "applicationInDesign-рокарий": "рокарий",
  "applicationInDesign-солитер (одиночное)": "солитер (одиночное)",
  "applicationInDesign-срезка": "срезка",
  "applicationInDesign-сухой букет": "сухой букет",
  "applicationInDesign-топиарные фигуры": "топиарные фигуры",
  "applicationInDesign-фитопластика": "фитопластика",
  "applicationInDesign-флористический дизайн": "флористический дизайн",
  "applicationInDesign-шпалера": "шпалера",
  "applicationInDesign-японский сад": "японский сад",

  "disease-альтернариоз": "альтернариоз",
  "disease-антракноз": "антракноз",
  "disease-астровый вилт": "астровый вилт",
  "disease-бактериальный ожог": "бактериальный ожог",
  "disease-бактериальная рябуха": "бактериальная рябуха",
  "disease-белая гниль": "белая гниль",
  "disease-белая пятнистость": "белая пятнистость",
  "disease-биаторелловый рак тиса": "биаторелловый рак тиса",
  "disease-бурая пятнистость": "бурая пятнистость",
  "disease-вертициллез": "вертициллез",
  "disease-вершинная гниль": "вершинная гниль",
  "disease-вирус люцерновой мозаики": "вирус люцерновой мозаики",
  "disease-вирус мозаики": "вирус мозаики",
  "disease-вирус некротической полосатости лилии": "вирус некротической полосатости лилии",
  "disease-вирус хосты X": "вирус хосты X",
  "disease-водянистая гниль": "водянистая гниль",
  "disease-гниль стебля": "гниль стебля",
  "disease-грибковые заболевания": "грибковые заболевания",
  "disease-кила капустных": "кила капустных",
  "disease-клястероспориоз": "клястероспориоз",
  "disease-корневая гниль": "корневая гниль",
  "disease-корневой рак": "корневой рак",
  "disease-ложная мучнистая роса": "пероноспороз (ложная мучнистая роса)",
  "disease-мозаичная болезнь листьев": "мозаичная болезнь листьев",
  "disease-мокрая бактериальная гниль": "мокрая бактериальная гниль",
  "disease-монтарь": "монтарь",
  "disease-мучнистая роса": "мучнистая роса",
  "disease-огуречная мозаика": "огуречная мозаика",
  "disease-оидиум винограда": "оидиум винограда",
  "disease-парша": "парша",
  "disease-пенициллез": "пенициллез",
  "disease-песталоциевый некроз": "песталоциевый некроз",
  "disease-пестролепестность": "пестролепестность",
  "disease-плодовая гниль (монилиоз)": "плодовая гниль (монилиоз)",
  "disease-подгар табака": "подгар табака",
  "disease-пожилковый хлороз": "пожилковый хлороз",
  "disease-пятнистость листьев": "пятнистость листьев",
  "disease-рак": "рак",
  "disease-рассадная (стеблевая) гниль": "рассадная (стеблевая) гниль",
  "disease-реверсия черной смородины": "реверсия черной смородины",
  "disease-ржавчина": "ржавчина",
  "disease-ризоктониоз (бурая гниль)": "ризоктониоз (бурая гниль)",
  "disease-сажистый гриб": "сажистый гриб",
  "disease-серая гниль": "серая гниль",
  "disease-серая плесень": "серая плесень",
  "disease-стаганоспороз": "стаганоспороз",
  "disease-стволовая гниль": "стволовая гниль",
  "disease-табачная мозаика": "табачная мозаика",
  "disease-у- вирус картофеля (белая пестрица)": "у- вирус картофеля (белая пестрица)",
  "disease-фитофтороз": "фитофтороз",
  "disease-фомоз": "фомоз",
  "disease-фомоз тиса": "фомоз тиса",
  "disease-фузариоз": "фузариоз",
  "disease-фузариозная пятнистость": "фузариозная пятнистость",
  "disease-фузариозное увядание": "фузариозное увядание",
  "disease-хлороз": "хлороз",
  "disease-церкоспороз": "церкоспороз",
  "disease-черная ножка": "черная ножка",
  "disease-черная пятнистость": "черная пятнистость",
  "disease-чернь": "чернь",
  "disease-шютте бурое": "шютте бурое",

  "pests-белокрылка": "белокрылка",
  "pests-блошка крестоцветная": "блошка крестоцветная",
  "pests-войлочный ореховый клещ": "войлочный ореховый клещ",
  "pests-галлицы": "галлицы",
  "pests-гороховая зерновка": "гороховая зерновка",
  "pests-гусеницы": "гусеницы",
  "pests-долгоносик": "долгоносик",
  "pests-еловая листовертка-иглоед": "еловая листовертка-иглоед",
  "pests-зонтичная моль": "зонтичная моль",
  "pests-капустная гусеница": "капустная гусеница",
  "pests-капустная муха": "капустная муха",
  "pests-клоп вонючий": "клоп вонючий",
  "pests-колорадский жук": "колорадский жук",
  "pests-комары-долгоножки": "комары-долгоножки",
  "pests-корневой луковый клещ": "корневой луковый клещ",
  "pests-крестоцветная блошка": "крестоцветная блошка",
  "pests-крот": "крот",
  "pests-лилейная муха": "лилейная муха",
  "pests-лилейный жук": "лилейный жук",
  "pests-листоблошка": "листоблошка",
  "pests-листовая блошка": "листовая блошка",
  "pests-листовертка": "листовертка",
  "pests-листоеды": "листоеды",
  "pests-луковая журчалка": "луковая журчалка",
  "pests-луковая муха": "луковая муха",
  "pests-луковый клещ": "луковый клещ",
  "pests-малинный жук": "малинный жук",
  "pests-медведка": "медведка",
  "pests-минирующая муха": "минирующая муха",
  "pests-муравьи": "муравьи",
  "pests-мучнистый червец": "мучнистый червец",
  "pests-мягкая ложнощитовка": "мягкая ложнощитовка",
  "pests-нематоды": "нематоды",
  "pests-огневка": "огневка",
  "pests-паутинный клещ": "паутинный клещ",
  "pests-пилильщик": "пилильщик",
  "pests-плодожорка": "плодожорка",
  "pests-полевая мышь": "полевая мышь",
  "pests-полевой клоп": "полевой клоп",
  "pests-полосатый долгоносик": "полосатый долгоносик",
  "pests-почковый клещ": "почковый клещ",
  "pests-проволочник": "проволочник",
  "pests-растительноядный клещ": "растительноядный клещ",
  "pests-самшитовая огневка": "самшитовая огневка",
  "pests-сельдерейная муха": "сельдерейная муха",
  "pests-слизни": "слизни",
  "pests-слюнявая пенница": "слюнявая пенница",
  "pests-стеблевая нематода": "стеблевая нематода",
  "pests-табачный проволочник": "табачный проволочник",
  "pests-тисовая галлица": "тисовая галлица",
  "pests-тисовая ложнощитовка": "тисовая ложнощитовка",
  "pests-тисовая плоскотелка": "тисовая плоскотелка",
  "pests-тисовый почковый клещ": "тисовый почковый клещ",
  "pests-тля": "тля",
  "pests-трипсы": "трипсы",
  "pests-тюльпановая огнёвка": "тюльпановая огнёвка",
  "pests-улитки": "улитки",
  "pests-фасолевая зерновка": "фасолевая зерновка",
  "pests-хрущ": "хрущ",
  "pests-цветочная пяденица": "цветочная пяденица",
  "pests-щитовка": "щитовка",

  "pesticideTreatmentFrequency-1 раз в неделю": "1 раз в неделю",
  "pesticideTreatmentFrequency-2 раза в неделю": "2 раза в неделю",
  "pesticideTreatmentFrequency-1 раз в месяц": "1 раз в месяц",
  "pesticideTreatmentFrequency-2 раза в месяц": "2 раза в месяц",
  "pesticideTreatmentFrequency-1 раз за сезон": "1 раз за сезон",
  "pesticideTreatmentFrequency-по мере необходимости": "по мере необходимости",
  "pesticideTreatmentFrequency-при определенных условиях": "при определенных условиях",

  "fertilizerFrequency-1 раз в неделю": "1 раз в неделю",
  "fertilizerFrequency-2 раза в неделю": "2 раза в неделю",
  "fertilizerFrequency-1 раз в 2 недели": "1 раз в 2 недели",
  "fertilizerFrequency-1 раз в месяц": "1 раз в месяц",
  "fertilizerFrequency-2 раза в месяц": "2 раза в месяц",
  "fertilizerFrequency-1 раз в месяц в вегетационный период": "1 раз в месяц в вегетационный период",
  "fertilizerFrequency-2 раза в месяц в вегетационный период": "2 раза в месяц в вегетационный период",
  "fertilizerFrequency-1 раз за сезон": "1 раз за сезон",
  "fertilizerFrequency-2 раза за сезон": "2 раза за сезон",
  "fertilizerFrequency-3-4 раза за сезон": "3-4 раза за сезон",
  "fertilizerFrequency-при определенных условиях": "при определенных условиях",

  "elementName-building": "здание",
  "elementName-building1": "здание 1",
  "elementName-building2": "здание 2",
  "elementName-building3": "здание 3",
  "elementName-building4": "здание 4",
  "elementName-building5": "здание 5",
  "elementName-building6": "здание 6",
  "elementName-building7": "здание 7",
  "elementName-building8": "здание 8",
  "elementName-building9": "здание 9",
  "elementName-building10": "здание 10",
  "elementName-building11": "здание 11",
  "elementName-building12": "здание 12",
  "elementName-building13": "здание 13",
  "elementName-building14": "здание 14",
  "elementName-building15": "здание 15",
  "elementName-building16": "здание 16",
  "elementName-building17": "здание 17",
  "elementName-building18": "здание 18",

  "elementName-garden": "сад",

  "elementName-lawn": "газон",

  "elementName-flowerbed": "клумба",
  "elementName-flowerbed1": "квадратная клумба",
  "elementName-flowerbed2": "круглая клумба",
  "elementName-flowerbed11": "квадратная клумба",
  "elementName-flowerbed22": "круглая клумба",

  "elementName-greenhouse": "теплица",
  "elementName-greenhouse1": "теплица 1",

  "elementName-vegetablegarden": "грядка",
  "elementName-veggardencabbage": "грядка - капуста",
  "elementName-veggarden11": "грядка 11",
  "elementName-veggarden12": "грядка 12",
  "elementName-veggarden2": "грядка 2",
  "elementName-veggarden4": "грядка 4",
  "elementName-veggarden7": "грядка 7",
  "elementName-veggarden26": "грядка 26",

  "elementName-tile": "плитка",
  "elementName-tile1": "плитка 1",
  "elementName-tile2": "плитка 2",
  "elementName-tile3": "плитка 3",
  "elementName-tile4": "плитка 4",
  "elementName-tile5": "плитка 5",
  "elementName-tile6": "плитка 6",

  "elementName-stairs": "лестница",
  "elementName-stairs1": "лестница 1",
  "elementName-stairs2": "лестница 2",

  "elementName-terrace": "терасса",
  "elementName-terrace1": "терасса 1",

  "elementName-patio": "патио",
  "elementName-patio1": "патио 1",
  "elementName-patio2": "патио 2",

  "elementName-fence": "забор",
  "elementName-fence1": "забор 1",
  "elementName-fence2": "забор 2",
  "elementName-fence3": "забор 3",
  "elementName-fence4": "забор 4",

  "elementName-entrance": "входная группа",
  "elementName-gate1": "двустворчатые ворота",
  "elementName-gate2": "одностворчатые ворота",
  "elementName-wicket": "калитка",

  "elementName-plantcomposition": "композиция растений",

  "elementName-rockery1": "рокарий 1",
  "elementName-rockery2": "рокарий 2",
  "elementName-rockery3": "рокарий 3",

  "elementName-tree": "дерево",
  "elementName-bush": "куст",
  "elementName-redBush": "красный куст",
  "elementName-grass": "трава",

  "elementName-structure": "беседка/павильон",
  "elementName-gazebo1": "газебо 1",

  "elementName-pathway": "дорога",
  "elementName-pathway1": "дорога 1",
  "elementName-pathway2": "дорога 2",
  "elementName-pathway3": "дорога 3",
  "elementName-pathway4": "дорога 4",
  "elementName-pathway5": "дорога 5",
  "elementName-pathway6": "дорога 6",
  "elementName-pathway7": "дорога 7",
  "elementName-pathway8": "дорога 8",
  "elementName-pathway9": "дорога 9",
  "elementName-pathway10": "дорога 10",
  "elementName-pathway11": "дорога 11",
  "elementName-pathway12": "дорога 12",
  "elementName-pathway13": "дорога 13",
  "elementName-pathway14": "дорога 14",

  "elementName-court": "корт ",
  "elementName-court1": "корт 1",
  "elementName-court2": "корт 2",

  "elementName-hedge": "живая изгородь",
  "elementName-hedge1": "живая изгородь 1",
  "elementName-hedge2": "живая изгородь 2",
  "elementName-hedge3": "живая изгородь 3",
  "elementName-hedge4": "живая изгородь 4",
  "elementName-hedge5": "живая изгородь 5",
  "elementName-hedge6": "живая изгородь 6",

  "elementName-tree1": "дерево 1",
  "elementName-treeapple": "фруктовое дерево",
  "elementName-bush3": "куст",
  "elementName-bush4": "куст",
  "elementName-bush6": "куст",
  "elementName-bush7": "куст",
  "elementName-grass_gray": "серая трава",
  "elementName-carex": "осока",
  "elementName-bushflowersorange": "куст с оранжевыми цветами",
  "elementName-bushflowersred": "куст с красными цветами",
  "elementName-boxwoodball": "шар",
  "elementName-cabbage": "капуста",
  "elementName-carrot": "морковь",
  "elementName-eggplant": "кабачок",
  "elementName-beet": "свекла",
  "elementName-onion": "лук",
  "elementName-salad": "салат",

  "elementName-waterpool1": "бассейн 1",
  "elementName-waterpool2": "бассейн 2",
  "elementName-waterpool3": "бассейн 3",
  "elementName-waterpool4": "бассейн 4",
  "elementName-waterpool5": "бассейн 5",
  "elementName-waterpool6": "бассейн 6",
  "elementName-waterpool7": "бассейн 7",
  "elementName-waterpool8": "бассейн 8",
  "elementName-waterpool9": "бассейн 9",

  "elementName-pool": "бассейн",
  "elementName-water": "водный элемент",
  "elementName-fountain1": "фонтан 1",
  "elementNamewaterfall2": "водопад 2",

  "elementName-stone1": "камень 1",
  "elementName-stone2": "камень 2",
  "elementName-stone3": "камень 3",
  "elementName-stone4": "камень 4",
  "elementName-flowerpot1": "горшок с цветком",
  "elementName-turtle": "черепаха",
  "elementName-car1": "машина",

  "elementName-sofa1": "диван",
  "elementName-chair1": "кресло",
  "elementName-table1": "стол",

  "elementName-lampball": "светильник шар",
  "elementName-lamp": "светильник",
  "elementName-spotlight": "направленный свет"
}
